var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.36,
    height: 58.131,
    viewBox: "0 0 56.36 58.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1b62ab;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-436.907 -390.308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(436.907 403.987)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M386.174,170.174h-1.087a1.087,1.087,0,0,1,0-2.174h1.087a1.087,1.087,0,1,1,0,2.174Zm0,0",
    transform: "translate(-376.568 -168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M283.221,218.174h-2.2a1.087,1.087,0,0,1,0-2.174h2.215a1.08,1.08,0,0,1,1.078,1.087A1.094,1.094,0,0,1,283.221,218.174Zm0,0",
    transform: "translate(-259.488 -209.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.076,217.087a1.087,1.087,0,0,1-1.087,1.087h-2.214a1.087,1.087,0,0,1,0-2.174h2.214A1.087,1.087,0,0,1,382.076,217.087Zm0,0",
    transform: "translate(-370.526 -209.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M338.4,170.174h-2.215a1.087,1.087,0,0,1,0-2.174H338.4a1.087,1.087,0,1,1,0,2.174Zm0,0",
    transform: "translate(-322.151 -168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M257.372,185.419a1.07,1.07,0,0,1-.225-.024,1.087,1.087,0,0,1-.84-1.286,2.292,2.292,0,0,0,.047-.451,2.18,2.18,0,0,0-.237-.989,1.087,1.087,0,0,1,1.938-.985,4.352,4.352,0,0,1,.379,2.869A1.087,1.087,0,0,1,257.372,185.419Zm0,0",
    transform: "translate(-230.447 -179.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.1,218.174h-2.215a1.087,1.087,0,0,1,0-2.174H332.1a1.087,1.087,0,0,1,0,2.174Zm0,0",
    transform: "translate(-314.999 -209.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.493,170.174h-2.215a1.087,1.087,0,1,1,0-2.174h2.215a1.087,1.087,0,0,1,0,2.174Zm0,0",
    transform: "translate(-266.6 -168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M211.434,296.82a1.062,1.062,0,0,1-.264.033,1.087,1.087,0,0,1-1.053-.824,3.835,3.835,0,0,0-.775-1.521,1.087,1.087,0,1,1,1.664-1.4,5.988,5.988,0,0,1,1.22,2.391,1.087,1.087,0,0,1-.791,1.319Zm0,0",
    transform: "translate(-177.802 -275.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M351.152,447.606a5.3,5.3,0,0,0,.7.045h1.368a1.087,1.087,0,1,1,0,2.174h-1.368a7.615,7.615,0,0,1-.978-.063,1.087,1.087,0,1,1,.278-2.156Zm0,0",
    transform: "translate(-338.991 -409.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.674,352.325a7.607,7.607,0,0,1,2.218-.326h.285a1.087,1.087,0,1,1,0,2.174h-.285a5.475,5.475,0,0,0-1.586.234,1.066,1.066,0,0,1-.316.048,1.086,1.086,0,0,1-.316-2.126Zm0,0",
    transform: "translate(-348.026 -327.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M344.056,282.174a1.087,1.087,0,1,1,0-2.174h2.214a1.087,1.087,0,0,1,0,2.174Zm0,0",
    transform: "translate(-331.091 -264.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M395.231,419.78a1.086,1.086,0,0,1,1.437.544,5.42,5.42,0,0,0,1.027,1.522,1.087,1.087,0,1,1-1.57,1.5,7.574,7.574,0,0,1-1.439-2.131A1.087,1.087,0,0,1,395.231,419.78Zm0,0",
    transform: "translate(-388.76 -385.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M439.151,257.122a1.087,1.087,0,0,1,1.351.735,3.3,3.3,0,0,0,.849,1.406,1.088,1.088,0,0,1-1.521,1.554,5.461,5.461,0,0,1-1.412-2.344,1.087,1.087,0,0,1,.734-1.351Zm0,0",
    transform: "translate(-438.371 -244.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M427.483,221.109a1.087,1.087,0,0,1-.81-1.813,5.468,5.468,0,0,1,2.282-1.513,1.087,1.087,0,1,1,.706,2.056,3.259,3.259,0,0,0-1.369.909A1.089,1.089,0,0,1,427.483,221.109Zm0,0",
    transform: "translate(-425.464 -210.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.095,352h2.214a1.087,1.087,0,1,1,0,2.174h-2.214a1.087,1.087,0,0,1,0-2.174Zm0,0",
    transform: "translate(-292.516 -327.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M392.95,280h2.215a1.087,1.087,0,1,1,0,2.174H392.95a1.087,1.087,0,1,1,0-2.174Zm0,0",
    transform: "translate(-386.628 -264.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M400.828,373.542a1.089,1.089,0,0,1,1.8,1.229,5.371,5.371,0,0,0-.761,1.668,1.087,1.087,0,1,1-2.1-.543A7.554,7.554,0,0,1,400.828,373.542Zm0,0",
    transform: "translate(-394.258 -345.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.142,339.576a3.865,3.865,0,0,0,1.323-1.081,1.087,1.087,0,0,1,1.717,1.333,6.033,6.033,0,0,1-2.078,1.7,1.087,1.087,0,0,1-.962-1.949Zm0,0",
    transform: "translate(-185.836 -314.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.287,448H206.5a1.087,1.087,0,1,1,0,2.173h-2.217a1.087,1.087,0,1,1,0-2.173Zm0,0",
    transform: "translate(-172.337 -409.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.287,448H206.5a1.087,1.087,0,1,1,0,2.173h-2.217a1.087,1.087,0,1,1,0-2.173Zm0,0",
    transform: "translate(-166.015 -409.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M302.118,448h2.214a1.087,1.087,0,1,1,0,2.173h-2.214a1.087,1.087,0,1,1,0-2.173Zm0,0",
    transform: "translate(-283.455 -409.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.255,282.174a1.087,1.087,0,0,1,0-2.174h2.214a1.087,1.087,0,0,1,0,2.174Zm0,0",
    transform: "translate(-220.003 -264.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M295.149,282.174a1.087,1.087,0,0,1,0-2.174h2.219a1.087,1.087,0,0,1,0,2.174Zm0,0",
    transform: "translate(-275.545 -264.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M261.192,352h2.215a1.087,1.087,0,0,1,0,2.174h-2.215a1.087,1.087,0,0,1,0-2.174Zm0,0",
    transform: "translate(-236.97 -327.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M253.216,448h2.215a1.087,1.087,0,0,1,0,2.173h-2.215a1.087,1.087,0,1,1,0-2.173Zm0,0",
    transform: "translate(-227.911 -409.962)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.824,231.056C5.139,227.408,0,219.7,0,216.176A8.006,8.006,0,0,1,7.824,208a8.006,8.006,0,0,1,7.824,8.176C15.648,219.7,10.509,227.41,7.824,231.056Zm0-19.422a3.637,3.637,0,0,0,0,7.268,3.637,3.637,0,0,0,0-7.268Zm0,0",
    transform: "translate(477.62 217.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.559,220.856C2.994,218.822,0,214.524,0,212.559a4.559,4.559,0,0,1,9.118,0C9.118,214.526,6.124,218.823,4.559,220.856Zm0-10.83a2.026,2.026,0,1,0,2.026,2.026A2.026,2.026,0,0,0,4.559,210.026Zm0,0",
    transform: "translate(437.529 182.308)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupIcon);
export default __webpack_public_path__ + "static/media/pickup-icon.c8e405a0.svg";
export { ForwardRef as ReactComponent };